import { LogLevel } from '@azure/msal-browser';

import {
  AZURE_CLIENT_ID,
  AZURE_ENABLE_LOGGING,
  AZURE_REDIRECT_URI,
  AZURE_TENANT_ID,
} from '../environmentVariables';

export const msalConfig = {
  auth: {
    clientId: AZURE_CLIENT_ID,
    authority: 'https://login.microsoftonline.com/' + AZURE_TENANT_ID,
    redirectUri: AZURE_REDIRECT_URI,
  },
  cache: {
    cacheLocation: 'localStorage',
  },
  system: {
    ...(AZURE_ENABLE_LOGGING === 'true' && {
      loggerOptions: {
        loggerCallback: (level: LogLevel, message: string, containsPii: boolean): void => {
          if (containsPii) {
            return;
          }
          switch (level) {
            case LogLevel.Error:
              console.error(message);
              return;
            case LogLevel.Info:
              console.info(message);
              return;
            case LogLevel.Verbose:
              console.debug(message);
              return;
            case LogLevel.Warning:
              console.warn(message);
              return;
          }
        },
        piiLoggingEnabled: false,
      },
    }),
  },
};
